<template>
  <div :class="['search-sort-bar', isExternalShare && 'external']">
    <div v-if="isExternalShare" class="placeholder has-border-bottom">{{$t('base.file')}}</div>
    <div v-else class="search-input" @click="onSearchInputClick">
      <van-field
        :value="$route.params.space === 'frequent' ? $t('file.searchInAll') : $t('file.search')"
        left-icon="search"
        disabled
      />
    </div>
    <div v-if="isExternalShare && !isMoreShare" class="sort-btn has-border-bottom" @click="onSortBtnClick">
      <i class="iconfont icon-sort1"></i><span>{{sortBy}}</span>
    </div>
    <div v-else-if="$route.params.module !== 'select_destination' && $route.params.space !== 'frequent' && !isMoreShare" class="sort-btn" @click="onSortBtnClick">
      <i class="iconfont icon-sort"></i>
    </div>
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import {sortByMap} from '@/utils/common'

export default {
  name: 'SearchSort',
  i18n,
  props: {
    isExternalShare: Boolean,
    isMoreShare: Boolean
  },
  computed: {
    sortBy () {
      return this.store.sortInfo ? i18n.t(sortByMap[this.store.sortInfo]) : ''
    }
  },
  methods: {
    onSearchInputClick () {
      this.$emit('search-input-click')
    },
    onSortBtnClick () {
      this.$emit('sort-btn-click')
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.search-sort-bar,
.search-contact {
  background: #fff;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  height: 48px;
  padding-left: 15px;

  &.external {
    height: 40px;
    font-size: 12px;
    color: #848484;

    & .placeholder,
    & .sort-btn {
      height: 39px;
      line-height: 39px;
    }

    & .placeholder {
      text-align: left;
    }

    & .sort-btn {
      display: flex;
      align-items: center;
    }

    & i {
      margin-right: 6px;
    }
  }

  & .placeholder,
  & .search-input {
    flex: 1 1 auto;
    padding-right: 15px;
  }

  & .van-field {
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    padding: 0 10px;
    background-color: #f6f7f9;
    color: var(--contentIcon);
  }

  & .van-cell__left-icon {
    line-height: 28px;
    color: var(--contentIcon);
  }

  & .sort-btn {
    flex: 0 0 auto;
    line-height: 28px;
    text-align: right;
    padding-right: 15px;
  }

  & .icon-sort {
    font-size: 20px;
    color: var(--contentIcon);
  }
}
</style>
